// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPlayVideo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="140" height="140" viewBox="0 0 140 140">
            <g fill="none" transform="translate(8 8)">
                <circle cx="62" cy="62" r="66" stroke="#FFF" strokeOpacity=".3" strokeWidth="8" />
                <circle
                    cx="62"
                    cy="62"
                    r="61"
                    fill="currentColor"
                    fillRule="evenodd"
                    stroke="#000000"
                    strokeWidth="2"
                />
                <path
                    fill="#FFF"
                    d="M81.7239584,57.9762938 C83.1390613,58.8407233 84,60.3632974 84,62.0037479 C84,63.6441999 83.1390613,65.166774 81.7239584,65.942795 L53.2269282,83.2313783 C51.760365,84.2038605 49.9246877,84.2431522 48.4264587,83.4081922 C46.9279321,82.5732322 46,81.0015428 46,79.2923312 L46,44.7151645 C46,43.009883 46.9279321,41.4372103 48.4264587,40.6022503 C49.9246877,39.7682736 51.760365,39.8026519 53.2269282,40.6916405 L81.7239584,57.9762938 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconPlayVideo);
